<mat-toolbar class="mc-header" [class.agency-header]="agencyService.agencyMode">
  <div class="mc-header__left-side">
    <div role="contentinfo" class="visually-hidden" mcAutofocus tabindex="0" [attr.aria-label]="pageTitle"></div>
    <a
      [attr.aria-label]="'Userway dashboard - ' + (homePage || 'my sites') + ' page'"
      role="link"
      class="mc-header__logo"
      tabindex="0"
      (click)="navigateToWidgetPage()"
    >
      <img
        src="{{ agencyService.agencyMode ? 'assets/icons/header-logo_aa.svg' : 'assets/icons/header-logo.svg' }}"
        class="mc-header__logo_img"
        alt="userway dashboard logo"
      />
      @if (agencyService.agencyMode) {
        <span class="mc-header__logo_user-email">{{ shortUserData.email }}</span>
      }
    </a>
  </div>

  <ng-container *permissionGuard="UserPermissions.notifications.topBar">
    <div class="top-notification">
      <div
        class="top-notification__toast toast-container"
        tabindex="0"
        aria-live="polite"
        aria-atomic="true"
        toastContainer
        id="top-notification-toast-container"
      ></div>
      <mc-top-notifications></mc-top-notifications>
    </div>
  </ng-container>

  <div class="mc-header__right-side" data-testid="header.right-side">
    <ng-container *permissionGuard="UserPermissions.manageSites.addSiteService">
      <mc-search-site
        [isAgency]="agencyService.agencyMode"
        *onlyRegTrackModeGuard="RegTrackMode.SearchField"
      ></mc-search-site>
    </ng-container>
    <div class="mc-header__controls">
      <ng-container *onlyRegTrackModeGuard="RegTrackMode.HeaderControls">
        <button
          *permissionGuard="UserPermissions.manageSites.addSiteService"
          walkThroughStep="addSite"
          type="button"
          class="mc-header__controls__btn mc-header__controls__btn_add"
          aria-label="Add sites"
          (click)="openAddSitesDrawer($event)"
          data-testid="header.add-sites-button"
        >
          <mat-icon
            aria-hidden="false"
            [svgIcon]="!agencyService.agencyMode ? 'plus_outline' : 'plus_outline_white'"
            class="icon-plus"
            aria-label="icon-plus"
          ></mat-icon>
        </button>

        <ng-container *permissionGuard="UserPermissions.notifications.drawer">
          <button
            type="button"
            walkThroughStep="notifications"
            class="mc-header__controls__btn mc-header__controls__btn_notif"
            aria-label="Latest notification"
            data-testid="header.notifications-button"
            (click)="openNotificationsDrawer()"
          >
            <mat-icon
              aria-hidden="false"
              [svgIcon]="!agencyService.agencyMode ? 'bell' : 'bell_white'"
              svgIcon="bell"
              class="icon-bell"
              aria-label="icon-bell"
            ></mat-icon>
            @if (unreadNotifCounter) {
              <span class="mc-header__controls__notif">{{ unreadNotifCounter }}</span>
            }
          </button>
        </ng-container>
      </ng-container>
      <mc-my-account-settings [isAgency]="agencyService.agencyMode" [userData]="shortUserData"></mc-my-account-settings>
    </div>
  </div>
</mat-toolbar>
